<div class="zone">
  <span #chiffre (animationend)="End($event)" class="chiffre">0</span>
</div>
